import { List } from "immutable"
import * as React from "react"
import { Block, BlockRenderer } from "../components/block_renderer"
import { Jumbo } from "../components/jumbo"
import * as DrupalModel from '../../custom_models/drupal'

export interface HomePageProps {
  readonly kind: "home"
  readonly pageTitle: string
  readonly headerTitle: string
  readonly description: string
  readonly headerButtonUrl: string
  readonly headerButtonTitle: string
  readonly imageUrl: string
  readonly imageAlt: string
  readonly blocks: List<Block>
  readonly showAnnouncement?: boolean
  readonly announcement?: string
  readonly selectedLocationId: string
  readonly branchLocations: DrupalModel.Location[]
  readonly selectLocation: (selectedId: string) => void
  readonly pageLanguage: string
}

interface HomePageState {
  input: string
}

export class HomePage extends React.Component<HomePageProps, HomePageState> {
  constructor(props: HomePageProps) {
    super(props)

    this.state = { input: "" }

    this.updateInput = this.updateInput.bind(this)
  }

  componentDidMount() {
    document.title = this.props.pageTitle
  }

  updateInput(i: string, c?: () => void) {
    this.setState((s, _) => ({ ...s, input: i }), c)
  }

  render() {
    const p = this.props
    const s = this.state

    return (
      <>
        {p.showAnnouncement && (
          <div className="announcement" role="alert">
            <div className="container-fluid" dangerouslySetInnerHTML={{ __html: p.announcement }} />
          </div>
        )}

        <div className="home wide">
          <Jumbo
            pageTitle={p.pageTitle}
            headerTitle={p.headerTitle}
            contents={p.description}
            headerImageUrl={p.imageUrl}
            headerImageAlt={p.imageAlt}
            buttonTitle={p.headerButtonTitle}
            buttonUrl={p.headerButtonUrl}
            size="large"
            kind="home"
            selectedLocationId={p.selectedLocationId}
            branchLocations={p.branchLocations}
            selectLocation={p.selectLocation}
          />

          <BlockRenderer blocks={p.blocks} />
        </div>
      </>
    )
  }
}
